import clsx from "clsx";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material";

import { Menu, MenuProps } from "../menu/Menu";
import { Archive } from "lucide-react";

import { ExerciseAssetStatus } from "@growth-machine-llc/stridist-api-client";
import useArchiveRestoreLibraryExerciseMutation from "../exercise-library/hooks/useArchiveRestoreLibraryExercise";

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: "999999 !important" as any,
  },
}));

export interface LibraryExerciseMenuProps extends MenuProps {
  assetId: number;
}

export function LibraryExerciseMenu(props: LibraryExerciseMenuProps) {
  const { className, onClose, assetId, ...other } = props;
  const s = useStyles();
  const { mutate: archiveAsset } = useArchiveRestoreLibraryExerciseMutation(
    ExerciseAssetStatus.PUBLISHED,
  );

  const handleArchiveClick = React.useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();

      archiveAsset({ id: assetId });
      if (onClose) {
        onClose(event, "backdropClick");
      }
    },
    [assetId, onClose, archiveAsset],
  );

  const handleClose = React.useCallback(
    (event, reason) => {
      event.stopPropagation();

      if (onClose) {
        onClose(event, reason);
      }
    },
    [onClose],
  );

  return (
    <Menu
      className={clsx(s.root, className)}
      styleVariant="inverse"
      onClose={handleClose}
      {...other}
    >
      <MenuItem onClick={handleArchiveClick} dense>
        <ListItemIcon children={<Archive />} />
        <ListItemText primary="Archive exercise" />
      </MenuItem>
    </Menu>
  );
}
